import script from "./PresenceCheckChanges.vue?vue&type=script&setup=true&lang=js"
export * from "./PresenceCheckChanges.vue?vue&type=script&setup=true&lang=js"

import "./PresenceCheckChanges.vue?vue&type=style&index=0&id=40438d20&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40438d20"]])

export default __exports__